/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shopping_Total_HelpInputs */

const en_shopping_total_help = /** @type {(inputs: Shopping_Total_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A rough estimate: whole packs at average prices`)
};

const de_shopping_total_help = /** @type {(inputs: Shopping_Total_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grob geschätzt: ganze Packungen zu Durchschnittspreisen`)
};

/**
* | output |
* | --- |
* | "A rough estimate: whole packs at average prices" |
*
* @param {Shopping_Total_HelpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_total_help = /** @type {((inputs?: Shopping_Total_HelpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_Total_HelpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_total_help(inputs)
	return en_shopping_total_help(inputs)
});